/**
 * Maps pathname to translation key for screen labels in the global feedback system.
 * Order matters: more specific paths should come first.
 */
const PATH_TO_LABEL_KEY = [
  { pattern: '/administration/users', key: 'nav.users' },
  { pattern: '/administration/master-data', key: 'nav.masterData' },
  { pattern: '/incoming-deliveries/stock', key: 'nav.incomingStock' },
  { pattern: '/incoming-deliveries', key: 'nav.incomingDeliveries' },
  { pattern: '/production-orders', key: 'nav.productionOrders' },
  { pattern: '/production-planning', key: 'nav.productionPlanning' },
  { pattern: '/production-recipes', key: 'nav.productionRecipes' },
  { pattern: '/trace-test-auto', key: 'nav.traceTestAuto' },
  { pattern: '/supplier-documents', key: 'nav.supplierDocuments' },
  { pattern: '/receive-goods', key: 'feedback.screenReceiveGoods' },
  { pattern: '/production-start', key: 'feedback.screenProductionStart' },
  { pattern: '/audits', key: 'nav.audits' },
  { pattern: '/recalls', key: 'nav.recalls' },
  { pattern: '/pallets', key: 'nav.pallets' },
  { pattern: '/dashboard', key: 'nav.dashboard' },
  { pattern: '/shopfloor', key: 'nav.shopfloor' },
  { pattern: '/stock', key: 'feedback.screenStock' },
  { pattern: '/processes', key: 'nav.processes' },
  { pattern: '/profile', key: 'nav.profile' },
  { pattern: '/help', key: 'nav.help' },
  { pattern: '/operator', key: 'feedback.screenOperator' },
];

/**
 * Get the translation key for a given pathname.
 * @param {string} pathname - e.g. /audits/123, /incoming-deliveries/456
 * @returns {string} Translation key (e.g. nav.audits)
 */
export function getScreenLabelKey(pathname) {
  if (!pathname || pathname === '/') return 'nav.dashboard';
  const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const found = PATH_TO_LABEL_KEY.find(({ pattern }) =>
    normalized === pattern || normalized.startsWith(`${pattern}/`)
  );
  return found ? found.key : 'feedback.screenGeneric';
}
